import { gql } from "@apollo/client";

const DELETE_TWILIO = gql`
  mutation deleteTwilioConfiguration($accountSID: String!) {
    deleteTwilioConfiguration(accountSID: $accountSID) {
      success
      error
      result
    }
  }
`;

export default DELETE_TWILIO;
